import React from 'react'
import Reactable from 'reactable'
import ReactPaginate from 'react-paginate'
require('../css/results.css')

var Table = Reactable.Table,
  Thead = Reactable.Thead,
  Th = Reactable.Th,
  Tr = Reactable.Tr,
  Td = Reactable.Td

export default class Results extends React.Component {
  constructor (props){
    super(props)

    this.state = {
      sort: null,
      order: null,
      pageNumber: 0,
    }
  }

  launchSearch(page=null, sort=null, order=null) {
    let sortMapping = {
      'name': 'title',
      'categoryname': 'category',
      'added': 'date',
      'size': 'size',
      'completed': 'completed',
      'seeders': 'seeds',
      'leechers': 'leechs',
    }
    sort = sortMapping[sort]

    order = order === 1 ? 'asc' : 'desc' // -1 or 1

    this.setState({
      sort: sort,
      order: order,
    })

    this.props.search(this.props.lastQuery, this.props.lastCategory, this.props.lastTracker, page, sort, order)
  }

  onSort(data) {
    this.setState({
      pageNumber: 0,
    })
    this.launchSearch(null, data['column'], data['direction'])
  }

  onPageChange(data, evt) {
    this.setState({
      pageNumber: data.selected,
    })
    this.launchSearch(data.selected + 1, this.state.sort, this.state.order)
  }

  render() {
    let mapping = {
      'All': 0,
      'Audio': 395,
      'eBook': 404,
      'Emulation': 340,
      'Jeu vidéo': 624,
      'GPS': 392,
      'Application': 233,
      'Film/Vidéo': 210,
      'Série': 211,
      'xXx': 456,
    }
    let resultItems = this.props.searchResults
    return (
      <div>
        <Table
          id="table"
          className="table table-hover"
          filterable={[]}
          noDataText="Pas de résultats"
          onSort={this.onSort.bind(this)}
          onPageChange={this.onPageChange.bind(this)}
          sortable={[
            {
              column: 'name',
              sortFunction: (a, b) => 0,
            },
            {
              column: 'categoryname',
              sortFunction: (a, b) => 0,
            },
            {
              column: 'added',
              sortFunction: (a, b) => 0,
            },
            {
              column: 'size',
              sortFunction: (a, b) => 0,
            },
            {
              column: 'completed',
              sortFunction: (a, b) => 0,
            },
            {
              column: 'seeders',
              sortFunction: (a, b) => 0,
            },
            {
              column: 'leechers',
              sortFunction: (a, b) => 0,
            },
          ]}
        >
          <Thead>
            <Th column="categoryname">Type</Th>
            <Th column="name">Nom</Th>
            <Th column="added">Age</Th>
            <Th column="size">Taille</Th>
            <Th column="completed">Complété</Th>
            <Th column="seeders">Seeders</Th>
            <Th column="leechers">Leechers</Th>
            <Th column="download">Download</Th>
          </Thead>
          {resultItems.map(function(row, i) {
            return (
              <Tr key={row.id}>
                <Td className={'cat' + mapping[row.parent_category]} column="categoryname">{row.category}</Td>
                <Td column="name"><a href={row.detailUrl} target="_blank">{row.name}</a></Td>
                <Td column="added">{row.added}</Td>
                <Td column="size">{row.size}</Td>
                <Td column="completed">{row.completed}</Td>
                <Td column="seeders">{row.seeders}</Td>
                <Td column="leechers">{row.leechers}</Td>
                <Td column="download">{row.download}</Td>
              </Tr>
            )
          })}
        </Table>
        <ReactPaginate
          previousLabel={'Précédent'}
          nextLabel={'Suivant'}
          breakLabel={'...'}
          pageCount={this.props.totalPages}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          forcePage={this.state.pageNumber}
          onPageChange={this.onPageChange.bind(this)}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/search/Results.js